import { Box, Container, Link } from "@chakra-ui/react";
import { NextPage } from "next";

import { MetaWrapper } from "@components/legacy";

const ContactView: NextPage = () => (
  <MetaWrapper
    meta={{
      description:
        "Need immediate assistance?  Kindly contact our customer service team on phone, email or live chat for any Hiring or Lending enquiries.",
      title: "Get Help | The Volte",
    }}
  >
    <>
      <Box padding="2rem 0rem">
        <Container maxW="1000px">
          <Box>
            <Box
              as="h1"
              padding="1rem 0rem"
              fontSize="3rem"
              textAlign="center"
              fontWeight={700}
            >
              Get the support you need
            </Box>
            <Box as="h3" padding="0.5rem 0rem" textAlign="center">
              We appreciate your patience. The Volte provides the below
              resources to help you get the support needed.{" "}
            </Box>
          </Box>
          <Box marginTop="2rem">
            <Box as="h4" padding="0.5rem 0rem" fontWeight={700}>
              Live Chat
            </Box>
            <Box as="p" padding="0.5rem 0rem">
              Click the Chat icon at the bottom right of the screen to receive
              support. If the Volte Bot can&apos;t answer your questions, you
              will be connected to a member of our Customer Support team when
              they&apos;re next available.
            </Box>
            <Box as="h4" padding="0.5rem 0rem" fontWeight={700}>
              Email
            </Box>
            <Box as="p" padding="0.5rem 0rem">
              Our Customer Support team is available 24/7 via email. Click the
              link below to contact us:
            </Box>
            <Box as="p" padding="0.5rem 0rem">
              {" "}
              <Link href="mailto:support@thevolte.com">
                support@thevolte.com
              </Link>
            </Box>
            <Box as="h4" padding="0.5rem 0rem" fontWeight={700}>
              Phone
            </Box>
            <Box as="p" padding="0.5rem 0rem">
              <Link href="tel:1800319370">1800 319 370</Link>
            </Box>
            <Box as="p" padding="0.5rem 0rem">
              Monday to Friday, 10:00am to 6:00pm (AEST/AEDT)
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  </MetaWrapper>
);
export default ContactView;
